import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Content from '@/modules/common/components/Content';
import GridItem from '@/modules/common/components/GridItem';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import GridContainer from '@/modules/common/components/GridContainer';
import { withFetch } from '~/hocs/fetch';
import Information from './Information';
import '../styles/Profile.scss';

let abortController;

const Profile = (props) => {
    let name;
    let breadcrumbs = [];

    const { username } = useParams();

    if (!username) {
        breadcrumbs.push({name: 'Профиль'});
        name = props.user.username;
    }
    else {
        breadcrumbs.push({name: 'Пользователи', to: '/users/'});
        breadcrumbs.push({name: username});
        name = username;
    }

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/users/${name}/`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setUser(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    useEffect(() => {
        fetch();
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    return (
        <Content id="profile">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6} xl={4}>
                        <Information loading={loading} user={user} fetch={fetch}/>
                    </GridItem>
                </GridContainer>
            </ContentBody>
        </Content>
    );
};

let Component = Profile;
Component = withFetch(Component);

export default connect(
    (state) => ({
        user: state.auth.user,
    })
)(Component);
